module.exports = __webpack_public_path__ + "img/features-tabs-icon-04.51fcf69f.svg";